<template>
  <div v-if="show">
    <div class="input_container">
      <wxc-radio
        label="Choose KYC mode option"
        :list="kycOptions"
        :config="radioButtonConfig"
        @wxcRadioListChecked="onKycOptionSelected($event.value)"
        ></wxc-radio>
    </div>

    <wxc-button
      text="Continue"
      class="button_horizontal_center margin_top_40"
      type="blue"
      @wxcButtonClicked="onContinueClicked"
      ></wxc-button>
  </div>
</template>

<script>

  import WxcRadio from "../../../weex-ui/packages/wxc-radio/index";
  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import AlertService from "../core/alert/AlertService";
  import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil"

  const SDK = "SDK";
  const OSV = "OSV";
  const SELECT_KYC_OPTION_MESSAGE = "Please select correct option for KYC";

  export default {
    name: 'KycOptionsItem',
    components: { WxcRadio, WxcButton },

    data: () => ({
      selectedKycOption: null,
      kycOptions: []
    }),

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      }
    },

    methods: {
      showKycOptionItem(kycOptions) {
        if (kycOptions && kycOptions.length > 0) {
          if (kycOptions.length === 1) {
            this.onKycOptionSelected(kycOptions[0]);
            this.onContinueClicked();
          } else {
            kycOptions && kycOptions.forEach(kycOption => {
              if (kycOption === OSV) {
                this.kycOptions.push({
                  title: "Upload Documents Manually",
                  value: kycOption
                });
              }
              if (kycOption === SDK) {
                this.kycOptions.push({
                  title: "Aadhaar based Digital KYC",
                  value: kycOption
                });
              }
            });
          }
        }
      },

      showToast(message) {
        AlertService.showToast(message);
      },

      onKycOptionSelected(selectedKycOption) {
        this.selectedKycOption = selectedKycOption;
      },

      onContinueClicked() {
        if (this.checkForValidation()) {
          if (SDK === this.selectedKycOption) {
            this.$emit("continueEKYC");
          }

          if (OSV === this.selectedKycOption) {
            this.$emit("continueManualKyc");
          }
        }
      },

      checkForValidation() {
        if (!this.selectedKycOption) {
          this.showToast(SELECT_KYC_OPTION_MESSAGE);
          return false;
        }
        return true;
      }
    },

    computed: {
      radioButtonConfig() {
        return DefaultResourceConfig.RADIO_BUTTON;
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
